import { render, staticRenderFns } from "./FormularioConcursoPublico.vue?vue&type=template&id=89f273c4&scoped=true&"
import script from "./FormularioConcursoPublico.vue?vue&type=script&lang=ts&"
export * from "./FormularioConcursoPublico.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioConcursoPublico.vue?vue&type=style&index=0&id=89f273c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f273c4",
  null
  
)

export default component.exports